import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefinitionComponent } from './definition/definition.component';
import { CostCtrRoutingModule } from './cost-ctr-routing.module';
import { CostCtrComponent } from './cost-ctr.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FacultyRangeComponent } from './faculty-range/faculty-range.component';
import { CcfAlphaComponent } from './ccf-alpha/ccf-alpha.component';
import { CcimprovementsComponent } from './ccf-improvements/ccf-improvements.component';
import { CcbuildingComponent } from './ccf-building/ccf-building.component';
import { CcotherComponent } from './ccf-other/ccf-other.component';
import { AgGridModule } from 'ag-grid-angular';
import { OrgCodeFilter } from './filters/org-code-filter';
@NgModule({
    declarations: [
        CostCtrComponent,
        DefinitionComponent,
        FacultyRangeComponent,
        CcfAlphaComponent,
        CcimprovementsComponent,
        CcbuildingComponent,
        CcotherComponent,
        OrgCodeFilter
    ],
    imports: [
        CommonModule,
        CostCtrRoutingModule,
        SharedModule,
        AgGridModule
    ]
})
export class CostCtrModule {}
